// extracted by mini-css-extract-plugin
export default {"wrapper":"BrandNot_wrapper__RbtEn","title":"BrandNot_title__fX9hZ","list":"BrandNot_list__zXkX9","link":"BrandNot_link__P5HSW"};